var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 1.875V11.0625C13.4375 11.8008 12.8223 12.375 12.125 12.375C11.3867 12.375 10.8125 11.8008 10.8125 11.0625V5.07422L2.52734 13.3184C2.03516 13.8516 1.17383 13.8516 0.681641 13.3184C0.148438 12.8262 0.148438 11.9648 0.681641 11.4727L8.92578 3.1875H2.9375C2.19922 3.1875 1.625 2.61328 1.625 1.875C1.625 1.17773 2.19922 0.5625 2.9375 0.5625H12.125C12.8223 0.5625 13.4375 1.17773 13.4375 1.875Z",
    fill: "#2F9240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/ArrowUpRight.6223429d9f90fc105ccd1e86e482fdf7.svg";
export { ForwardRef as ReactComponent };